import { Outlet } from 'react-router-dom';

import { cn } from 'noddi-ui-common';
import { BasicHeaderNav } from './BasicHeaderNav';
import { PageLayoutProvider } from './PageLayoutProvider';
import { MainContent, SkipToMainContent } from './SkipToMainContent';
import { usePageBackground } from './usePageBackground';

export const BasicRouterLayout = ({ className }: { className?: string }) => (
  <PageLayoutProvider>
    <BasicRouterLayoutInner className={className} />
  </PageLayoutProvider>
);

const BasicRouterLayoutInner = ({ className }: { className?: string }) => {
  const background = usePageBackground();
  return (
    <div
      className={cn(
        'min-h-screen',
        background === 'grouped' ? 'bg-grouped-background' : 'bg-primary-background-gradient',
        className
      )}
    >
      <SkipToMainContent />
      <BasicHeaderNav />
      <MainContent>
        <Outlet />
      </MainContent>
    </div>
  );
};
